import { Box, Dialog, DialogContent, Link } from "@mui/material"
import React, { FC, useState } from "react"
import { StyledCloseIcon, StyledDialogInner, StyledDialogErrorMessageBox, StyledDialogMessageBoxMessage, StyledDialogTitle, StyledDialogTitleBox, StyledDialogMessageBox } from "./FileImportDialog.styles"
import { FileImporter } from "../../molecules/Form/FileImporter/FileImporter"
import DownloadIcon from "@mui/icons-material/Download"
import { orderRepository } from "~/src/repositories"
import { useTranslation } from "react-i18next"


interface IFileImportDialogProps {
  dialogToggleState: boolean,
  dialogTitle: string,
  onImportFile: (file: File) => void
  closeDialog: () => void
}

export const FileImportDialog: FC<IFileImportDialogProps> = ({
  dialogToggleState,
  dialogTitle,
  onImportFile,
  closeDialog,
  template,
}): JSX.Element => {
  const [file, setFile] = useState<string>('')
  const [loading, setLoading] = useState<boolean>(false)
  const [messages, setMessages] = useState<string[]>([])
  const [errors, setErrors] = useState<string[]>([])
  const [isDownloading, setIsDownloading] = useState<boolean>(false)
  const { t } = useTranslation()

  const close = async () => {
    await closeDialog()
    setMessages([])
    setErrors([])
  }

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return
    setMessages([])
    setErrors([])
    setFile(URL.createObjectURL(e.target.files[0]))
    setLoading(true)
    const result = await onImportFile(e.target.files[0])
    console.log(result)
    setMessages(result.messages)
    setErrors(result.errors)
    e.target.value = ''
    setLoading(false)
  }

  const handleDownloadTemplate = async (template: string) => {
    if (isDownloading) return
    setIsDownloading(true)
    let data
    let fileName: string
    if (template == 'engine') {
      const res = await orderRepository.downloadTemplateEngineFile()
      data = res.data
      fileName = t('contact_order.engine_template_file_name')
    }
    else if (template == 'ckd_part') {
      const res = await orderRepository.downloadTemplateCkdPartFile()
      data = res.data
      fileName = t('contact_order.ckd_part_template_file_name')
    }
    if (data) {
      const url = URL.createObjectURL(new Blob([data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', fileName)
      link.click()
      link.remove()
      URL.revokeObjectURL(url)
    }
    setIsDownloading(false)
  }

  return (
    <Dialog open={dialogToggleState}>
      <StyledDialogInner>
        <StyledDialogTitleBox>
          <StyledDialogTitle>
            {dialogTitle}
          </StyledDialogTitle>
          <StyledCloseIcon onClick={close} />
        </StyledDialogTitleBox>
      </StyledDialogInner>
      <DialogContent>
        {template &&
          <Link>
            <Box
              sx={{
                width: '240px',
                textDecoration: 'underline',
                display: 'flex',
                alignItems: 'center',
                marginBottom: '15px',
                cursor: 'pointer',
              }}
              onClick={() => handleDownloadTemplate(template)}
            >
              <DownloadIcon sx={{ fontSize: '20px' }} />
              {t('contact_order.template_download')}
            </Box>
          </Link>
        }
        <FileImporter
          loading={loading}
          handleFileChange={handleFileChange}
        />
        <StyledDialogMessageBox
          marginTop={2}
          display={messages.length > 0 ? '' : 'none'}
        >
          {messages.map((message, index) => (
            <StyledDialogMessageBoxMessage key={index}>{message}</StyledDialogMessageBoxMessage>
          ))}
        </StyledDialogMessageBox>
        <StyledDialogErrorMessageBox
          marginTop={2}
          display={errors.length > 0 ? '' : 'none'}
        >
          {errors.map((error, index) => (
            <StyledDialogMessageBoxMessage key={index}>{error}</StyledDialogMessageBoxMessage>
          ))}
        </StyledDialogErrorMessageBox>
      </DialogContent>
    </Dialog>
  )
}